import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'campaignResult'
})
export class CampaignResultPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (value) {
      return value; 
    }
    return "No Result Recorded";
  }

}
